import React from 'react'

interface ComponentProps {
  children: React.ReactChildren | JSX.Element
}

function NavAppWrapper({ children }: ComponentProps) {
  return (
    <div>
      <style>
        {`
        body {
          padding-left: 18.75%;
        }
      `}
      </style>
      <link
        rel='stylesheet'
        href={`${process.env.PUBLIC_URL}/assets.css`}
        type='text/css'
      />

      <div
        data-component-name='header'
        data-component-container='true'
        className='nr-header-component nr-component aem-GridColumn aem-GridColumn--default--12'
      >
        <header className='nr-header false'>
          <div className='nr-header__inner-wrap nr-clearfix'>
            <div className='nr-header__container'>
              <ul className='nr-header__links'>
                <li className='nr-header__link-wrap'>
                  <a
                    href='/en/global/corporate/careers/search-and-apply.html'
                    className='nr-header__link'
                  >
                    <i className='nr-icon-careers nr-header__icon'></i>
                    <span className='nr-header__link-text'>Join bp</span>
                  </a>
                </li>
              </ul>
              <ul className='nr-header__links nr-header__sitetunnel'>
                <li className='nr-header__link-wrap'>
                  <a
                    href='/en/global/corporate/what-we-do/bp-worldwide/_jcr_content/root/sitetunnel.html'
                    className='nr-header__link nr-header__sitetunnel-overlay-link'
                  >
                    <i className='nr-icon-global nr-header__icon'></i>
                    <span className='nr-header__link-text'>Worldwide</span>
                  </a>
                  <div className='nr-header__sitetunnel-overlay-content'></div>
                </li>
              </ul>
              <form
                action='/en/global/corporate/search-results.html'
                method='GET'
                className='nr-header__search-outer-wrap'
              >
                <div className='nr-header__search'>
                  <div className='nr-header__search-inner-wrap'>
                    <div className='nr-header__search-icon-wrap'>
                      <button type='submit' className='nr-header__search-btn'>
                        <i className='nr-icon-search-2 nr-header__icon'></i>
                        <span className='nr-visually-hidden'>Search</span>
                      </button>
                    </div>
                    <label htmlFor='q' className='nr-visually-hidden'>
                      Search
                    </label>
                    <input
                      placeholder='Search'
                      id='q'
                      name='q'
                      className='nr-header__input'
                      type='hidden'
                      aria-hidden='true'
                      disabled
                    />
                  </div>
                </div>
                <div
                  data-component-name='searchPopup'
                  className='nr-component nr-search-popup'
                  data-algolia-id='RF87OIMXXP'
                  data-algolia-key='8718692f759f5c8fa74277dfb3fd9b99'
                  data-algolia-results='preprod-www-navitas.bp.com'
                  data-algolia-suggestions='preprod_bp_query_suggestions'
                  aria-hidden='true'
                >
                  <div
                    className='nr-search-popup-recent'
                    data-listbox-description='Recent Suggestions'
                  ></div>
                  <div
                    className='nr-search-popup-results'
                    data-listbox-description='Search Suggestions'
                  ></div>
                  <div
                    className='nr-search-popup-suggestions'
                    data-listbox-description='Search Result'
                  >
                    <div className='nr-search-popup-suggestions-title'>
                      Suggestions
                    </div>
                    <div className='nr-search-popup-suggestions-links'></div>
                    <a href='#' className='nr-search-popup-suggestions-viewall'>
                      View all results
                      <i className='nr-icon nr-icon-arrow'></i>
                    </a>
                  </div>
                </div>
              </form>
              <p className='nr-header__tagline'></p>
            </div>
          </div>
        </header>
      </div>
      <div
        data-component-name='navigation'
        data-component-container='true'
        className='nr-component aem-GridColumn aem-GridColumn--default--12'
      >
        <div className='nr-navigation__burger'></div>
        <div className='nr-navigation__overlay' data-overlay='true'></div>
        <aside className='nr-navigation '>
          <div className='nr-navigation__inner '>
            <section className='nr-navigation__header'>
              <a href='/' className='nr-navigation__logo'>
                <img
                  className='nr-navigation__logo-img'
                  width='100%'
                  height='100%'
                  src={`${process.env.PUBLIC_URL}/images/bp-logo.svg`}
                  alt='BP Logo'
                />
              </a>
            </section>

            <div
              className='nr-navigation__shareprice nr-navigation__shareprice--mobile-type nr-navigation__shareprice--initialized'
              data-format='ticker'
              data-feed-timeout='60000'
              data-feed-url='https://apps.bp.com/SharePriceFeed'
              data-x-api-key='aDOMiHooE68nd3QXUztCi9Al8HnoAyTu4QrAzv0M'
            >
              <p className='nr-navigation__shareprice-text nr-navigation__shareprice--down'>
                GBp
                <span
                  className='nr-navigation__shareprice--amount'
                  data-key='ldn-currentPrice'
                >
                  373.85
                </span>
                <span className='nr-navigation__shareprice-change'>
                  (<span data-key='ldn-positiveTrend'></span>
                  <span data-key='ldn-currentTrend'>-0.55</span>)
                </span>
              </p>
              <p className='nr-navigation__shareprice-text nr-navigation__shareprice--up'>
                USD
                <span
                  className='nr-navigation__shareprice--amount'
                  data-key='nyc-currentPrice'
                >
                  30.11
                </span>
                <span className='nr-navigation__shareprice-change'>
                  (<span data-key='nyc-positiveTrend'>+</span>
                  <span data-key='nyc-currentTrend'>1.62</span>)*
                </span>
              </p>

              <p className='nr-navigation__shareprice-error-message'>
                Share price unavailable
              </p>
            </div>

            <div className='nr-navigation__controller nr-navigation__controller--subpage'>
              <div className='nr-navigation__list-wrapper nr-navigation__list-wrapper--first nr-navigation__list-active'>
                <button
                  aria-label='previous'
                  className='nr-navigation__prev-btn nr-navigation__remove-animate nr-navigation__hide-btn'
                >
                  <i className='nr-icon-arrow'></i>
                  <span className='nr-visually-hidden'>previous</span>
                </button>

                <nav
                  className='nr-navigation__container nr-navigation__container--sublevel'
                  data-level='0'
                  data-current-page-level='2'
                  role='navigation'
                >
                  <div className='nr-navigation__item nr-navigation__list-title nr-navigation__list-title--back'>
                    <a
                      className='nr-navigation__link nr-navigation__link--back'
                      data-type='back'
                      href='#'
                    >
                      <i className='nr-icon nr-icon-arrow-title'></i>
                      <span className='nr-navigation__link--back-desktop'>
                        Menu
                      </span>
                      <span className='nr-navigation__link--back-mobile'>
                        Back
                      </span>
                    </a>
                  </div>

                  <ul className='nr-navigation__list'>
                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15'
                      >
                        Energy Outlook Pages
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-1-.html'
                        className='
                nr-navigation__link
                nr-navigation__link--active

            '
                        data-type='link'
                        data-index='15,0'
                      >
                        Energy Outlook (Page 1)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-2-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,1'
                      >
                        Energy Outlook (Page 2)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-3-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,2'
                      >
                        Energy Outlook (Page 3)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-4-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,3'
                      >
                        Energy Outlook (Page 4)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-5-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,4'
                      >
                        Energy Outlook (Page 5)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-6-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,5'
                      >
                        Energy Outlook (Page 6)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,6'
                      >
                        Energy Outlook (Page 7)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-8-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,7'
                      >
                        Energy Outlook (Page 8)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-9-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,8'
                      >
                        Energy Outlook (Page 9)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-10-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,9'
                      >
                        Energy Outlook (Page 10)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-11-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,10'
                      >
                        Energy Outlook (Page 11)
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages/energy-outlook--page-12-.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='15,11'
                      >
                        Energy Outlook (Page 12)
                      </a>
                    </li>
                  </ul>
                </nav>

                <nav
                  className='nr-navigation__container nr-navigation__container--mainlevel'
                  data-level='0'
                  role='navigation'
                >
                  <div className='nr-navigation__item nr-navigation__list-title'>
                    <a
                      className='nr-navigation__link'
                      href='/'
                      data-type='link'
                    >
                      Home
                    </a>
                  </div>

                  <ul className='nr-navigation__list'>
                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/who-we-are.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='0'
                      >
                        Who we are
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/what-we-do.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='1'
                      >
                        What we do
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/products-and-services.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='2'
                      >
                        Global products and services
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/careers.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='3'
                      >
                        Careers
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/investors.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='4'
                      >
                        Investors
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/news-and-insights.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='5'
                      >
                        News and insights
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/sustainability.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='6'
                      >
                        Sustainability
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-economics.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='7'
                      >
                        Energy economics
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/podcast.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='8'
                      >
                        Podcast
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/podbean-navapp.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='9'
                      >
                        Podbean-Navapp
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/pnv.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='10'
                      >
                        PnV
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/navapp-testing.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='11'
                      >
                        Navapp testing
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/testing.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='12'
                      >
                        Testing
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/test.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='13'
                      >
                        Test
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/tst.html'
                        className='
                nr-navigation__link


            '
                        data-type='link'
                        data-index='14'
                      >
                        tst
                      </a>
                    </li>

                    <li className='nr-navigation__item'>
                      <a
                        href='/en/global/corporate/energy-outlook-pages.html'
                        className='
                nr-navigation__link


            '
                        data-type='section'
                        data-index='15'
                      >
                        Energy Outlook Pages
                        <i className='nr-icon nr-icon-arrow'></i>
                      </a>
                    </li>
                  </ul>

                  <ul className='nr-navigation__borrowed-links'>
                    <li className='nr-navigation__borrowed-link'>
                      <a
                        className='nr-navigation__link'
                        data-type='link'
                        href='/en/global/corporate/careers/search-and-apply.html'
                      >
                        <i className='nr-icon nr-icon-careers nr-navigation__link-icon'></i>

                        <span>Join bp</span>
                      </a>
                    </li>
                  </ul>

                  <ul className='nr-navigation__borrowed-links'>
                    <li className='nr-navigation__borrowed-link'>
                      <a
                        href='/en/global/corporate/what-we-do/bp-worldwide/_jcr_content/root/sitetunnel.html'
                        className='
                                            nr-navigation__link
                                            nr-navigation__sitetunnel-overlay-link'
                      >
                        <i className='nr-icon nr-navigation__link-icon nr-icon-globe'></i>

                        <span>Worldwide</span>
                      </a>

                      <div className='nr-navigation__sitetunnel-overlay-content'></div>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className='nr-navigation__footer'>
                <div className='nr-navigation__quick-links'>
                  <ul className='nr-navigation__list nr-navigation__list--bottom'>
                    <li className='nr-navigation__list-item'>
                      <a
                        href='/en/global/corporate/news-and-insights/reimagining-energy.html'
                        className='nr-navigation__quick-link'
                        target='_self'
                      >
                        <span className='nr-navigation__link-text'>
                          Reimagining energy
                        </span>
                      </a>
                    </li>

                    <li className='nr-navigation__list-item'>
                      <a
                        href='/en/global/corporate/newsletter.html'
                        className='nr-navigation__quick-link'
                        target='_self'
                      >
                        <span className='nr-navigation__link-text'>
                          Sign up for news
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div
                  className='nr-navigation__shareprice nr-navigation__shareprice--desktop-type nr-navigation__shareprice--initialized'
                  data-format='ticker'
                  data-feed-timeout='60000'
                  data-feed-url='https://apps.bp.com/SharePriceFeed'
                  data-x-api-key='aDOMiHooE68nd3QXUztCi9Al8HnoAyTu4QrAzv0M'
                >
                  <p className='nr-navigation__shareprice-text nr-navigation__shareprice--down'>
                    GBp
                    <span
                      className='nr-navigation__shareprice--amount'
                      data-key='ldn-currentPrice'
                    >
                      373.85
                    </span>
                    <span className='nr-navigation__shareprice-change'>
                      (<span data-key='ldn-positiveTrend'></span>
                      <span data-key='ldn-currentTrend'>-0.55</span>)
                    </span>
                  </p>
                  <p className='nr-navigation__shareprice-text nr-navigation__shareprice--up'>
                    USD
                    <span
                      className='nr-navigation__shareprice--amount'
                      data-key='nyc-currentPrice'
                    >
                      30.11
                    </span>
                    <span className='nr-navigation__shareprice-change'>
                      (<span data-key='nyc-positiveTrend'>+</span>
                      <span data-key='nyc-currentTrend'>1.62</span>)*
                    </span>
                  </p>

                  <p className='nr-navigation__shareprice-error-message'>
                    Share price unavailable
                  </p>
                </div>
              </div>
            </div>
          </div>
        </aside>
        <div className='nr-navigation__overlay-content' data-overlay='true'>
          <button
            title='close overlay'
            className='nr-navigation__overlay-content-close'
          >
            <i className='nr-icon nr-icon-close'></i>
            <span className='nr-visually-hidden'>close overlay</span>
          </button>
          <div className='nr-navigation__overlay-content-search'>
            <form
              action='/en/global/corporate/search-results.html'
              method='GET'
              className='nr-navigation__search-outer-wrap'
            >
              <label
                htmlFor='nr-navigation-search'
                className='nr-navigation__search-label'
              >
                Search
              </label>
              <input
                id='nr-navigation-search'
                placeholder='Search'
                name='q'
                className='nr-navigation__input'
                type='text'
                aria-hidden='true'
                disabled
              />
              <div className='nr-navigation__search'>
                <div className='nr-navigation__search-inner-wrap'>
                  <div className='nr-navigation__search-icon-wrap'>
                    <button
                      type='submit'
                      title='search'
                      className='nr-navigation__search-btn'
                    >
                      <i className='nr-icon-search'></i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                data-component-name='searchPopup'
                className='nr-component nr-search-popup'
                data-algolia-id='RF87OIMXXP'
                data-algolia-key='8718692f759f5c8fa74277dfb3fd9b99'
                data-algolia-results='preprod-www-navitas.bp.com'
                data-algolia-suggestions='preprod_bp_query_suggestions'
                aria-hidden='true'
              >
                <div
                  className='nr-search-popup-recent'
                  data-listbox-description='Recent Suggestions'
                ></div>
                <div
                  className='nr-search-popup-results'
                  data-listbox-description='Search Suggestions'
                ></div>
                <div
                  className='nr-search-popup-suggestions'
                  data-listbox-description='Search Result'
                >
                  <div className='nr-search-popup-suggestions-title'>
                    Suggestions
                  </div>
                  <div className='nr-search-popup-suggestions-links'></div>
                  <a href='#' className='nr-search-popup-suggestions-viewall'>
                    View all results
                    <i className='nr-icon nr-icon-arrow'></i>
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        data-component-name='breadcrumb'
        className='nr-breadcrumb-component nr-component aem-GridColumn aem-GridColumn--default--12'
      >
        <div>
          <ol className='nr-breadcrumb' typeof='BreadcrumbList'>
            <li
              className='nr-breadcrumb__item'
              property='itemListElement'
              typeof='ListItem'
            >
              <a
                href='/'
                property='item'
                typeof='WebPage'
                className='nr-breadcrumb__link'
              >
                Home
              </a>
            </li>
            <li
              className='nr-breadcrumb__item'
              property='itemListElement'
              typeof='ListItem'
            >
              <a
                href='/en/global/corporate/energy-outlook-pages.html'
                property='item'
                typeof='WebPage'
                className='nr-breadcrumb__link'
              >
                Energy Outlook Pages
              </a>
            </li>
            <li
              className='nr-breadcrumb__item nr-breadcrumb__item--inactive'
              property='itemListElement'
              typeof='ListItem'
            >
              <span className='nr-breadcrumb__link nr-breadcrumb__link--inactive'>
                Energy Outlook (Page 1)
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div className='aem-Grid aem-Grid--12 aem-Grid--default--12 '>
        <div
          data-component-name='pagetitle'
          className='nr-component nr-page-title aem-GridColumn aem-GridColumn--default--12'
        >
          <div className='nr-row'>
            <div className='nr-page-title__wrapper '>
              <div className='nr-page-title__wrap '>
                <div className='nr-page-title__wrap-inner '>
                  <section className='nr-page-title__header'>
                    <h1 className='nr-page-title__header--title'>
                      Energy Outlook (Page 1)
                    </h1>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-component-name='layout'
          data-component-container='true'
          className='nr-layout-component nr-component aem-GridColumn aem-GridColumn--default--12'
        >
          <div className='nr-layout aem-Grid aem-Grid--12 aem-Grid--default--12  '>
            <div
              className='nr-layout__wrapper
                     nr-layout__wrapper--stacked
                     nr-layout__wrapper--full
                     nr-layout__wrapper--top'
            >
              <div
                data-component-name='navApp'
                data-component-container='true'
                className='nr-component nr-nav-app-component aem-GridColumn aem-GridColumn--default--12'
              >
                <div>
                  <div
                    className='nr-navapp'
                    tabIndex={0}
                    data-uid='bp Global Energy Outlook'
                    data-url='https://bp-com-cm.navitas.bpglobal.com/bp-global-energy-outlook/page-1-section-1/index.html'
                  >
                    {children}
                  </div>
                </div>
              </div>
              <div
                data-component-name='divider'
                data-component-container='true'
                className='nr-divider-component nr-component aem-GridColumn aem-GridColumn--default--12'
              >
                <div className='nr-divider nr-divider--grey'></div>
              </div>
              <div className='nr-layout__component new section aem-Grid-newComponent'></div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-component-name='footer'
        data-component-container='true'
        className='nv-footer-component nv-component aem-GridColumn aem-GridColumn--default--12'
      >
        <footer
          className='nr-footer nr-row disclaimer-is-hidden'
          role='contentinfo'
        >
          <div className='nr-footer__wrapper'>
            <div className='nr-footer__content'>
              <div className='nr-row'>
                <aside className='nr-footer__aside nr-col-extra-large-9 nr-col-large-8 nr-col-medium-15 nr-col-small-8 nr-col-extra-small-16'>
                  <p className='nr-footer__inscription'>bp p.l.c.</p>
                  <p className='nr-footer__rights'>Copyright © 1996-2021</p>
                </aside>
                <ul className='nr-footer__nav nr-clearfix nr-col-large-24 nr-col-extra-large-23 nr-col-medium-17 nr-col-small-8 nr-col-extra-small-16 nr-row'>
                  <li className='nr-col-large-10 nr-col-medium-14 nr-col-small-7 nr-col-extra-small-16'>
                    <a
                      className='nr-footer__nav-item nr-footer__links'
                      href='/en/global/corporate/legal-notice.html'
                      target='_self'
                    >
                      Legal notice
                    </a>
                  </li>
                  <li className='nr-col-large-10 nr-col-medium-14 nr-col-small-7 nr-col-extra-small-16'>
                    <a
                      className='nr-footer__nav-item nr-footer__links'
                      href='/en/global/corporate/privacy-statement.html'
                      target='_self'
                    >
                      Privacy statement
                    </a>
                  </li>
                  <li className='nr-col-large-10 nr-col-medium-14 nr-col-small-7 nr-col-extra-small-16'>
                    <a
                      className='nr-footer__nav-item nr-footer__links'
                      href='/en/global/corporate/contact-us.html'
                      target='_self'
                    >
                      Contact us
                    </a>
                  </li>
                  <li className='nr-col-large-10 nr-col-medium-14 nr-col-small-7 nr-col-extra-small-16'>
                    <a
                      className='nr-footer__nav-item nr-footer__links'
                      href='/en/global/corporate/site-map.html'
                      target='_self'
                    >
                      Sitemap
                    </a>
                  </li>
                  <li className='nr-col-large-10 nr-col-medium-14 nr-col-small-7 nr-col-extra-small-16'>
                    <a
                      className='nr-footer__nav-item nr-footer__links'
                      href='/en/global/corporate/cookie-preferences.html'
                      target='_self'
                    >
                      Cookie preferences
                    </a>
                  </li>
                  <li className='nr-col-large-10 nr-col-medium-14 nr-col-small-7 nr-col-extra-small-16'>
                    <a
                      className='nr-footer__nav-item nr-footer__links'
                      href='/en/global/corporate/careers.html'
                      target='_self'
                    >
                      Careers
                    </a>
                  </li>
                </ul>
                <p className='nr-footer__social-title'>Connect with us on:</p>
                <ul className='nr-footer__social nr-clearfix'>
                  <li className='nr-footer__social-item'>
                    <a
                      className='nr-footer__link nr-footer__links'
                      rel='noopener'
                      href='https://www.facebook.com/bp/'
                      target='_blank'
                    >
                      <img
                        src='https://bp-com-cm.navitas.bpglobal.com/content/dam/bp/master-site/en/global/home/images/social_icons/fb.svg'
                        width='20px'
                        height='20px'
                        className='nr-footer__icon'
                        alt='Facebook'
                      />
                    </a>
                  </li>
                  <li className='nr-footer__social-item'>
                    <a
                      className='nr-footer__link nr-footer__links'
                      rel='noopener'
                      href='https://twitter.com/bp_plc'
                      target='_blank'
                    >
                      <img
                        src='https://bp-com-cm.navitas.bpglobal.com/content/dam/bp/master-site/en/global/home/images/social_icons/twitter.svg'
                        width='20px'
                        height='20px'
                        className='nr-footer__icon'
                        alt='Twitter'
                      />
                    </a>
                  </li>
                  <li className='nr-footer__social-item'>
                    <a
                      className='nr-footer__link nr-footer__links'
                      rel='noopener'
                      href='https://www.linkedin.com/company/bp'
                      target='_blank'
                    >
                      <img
                        src='https://bp-com-cm.navitas.bpglobal.com/content/dam/bp/master-site/en/global/home/images/social_icons/linkedin.svg'
                        width='20px'
                        height='20px'
                        className='nr-footer__icon'
                        alt='Linkedin'
                      />
                    </a>
                  </li>
                  <li className='nr-footer__social-item'>
                    <a
                      className='nr-footer__link nr-footer__links'
                      rel='noopener'
                      href='https://www.instagram.com/bp_plc'
                      target='_blank'
                    >
                      <img
                        src='https://bp-com-cm.navitas.bpglobal.com/content/dam/bp/master-site/en/global/home/images/social_icons/instagram.svg'
                        width='20px'
                        height='20px'
                        className='nr-footer__icon'
                        alt='Instagram'
                      />
                    </a>
                  </li>
                  <li className='nr-footer__social-item'>
                    <a
                      className='nr-footer__link nr-footer__links'
                      rel='noopener'
                      href='https://www.youtube.com/bp'
                      target='_blank'
                    >
                      <img
                        src='https://bp-com-cm.navitas.bpglobal.com/content/dam/bp/master-site/en/global/home/images/social_icons/youtube.svg'
                        width='20px'
                        height='20px'
                        className='nr-footer__icon'
                        alt='Youtube'
                      />
                    </a>
                  </li>
                  <li className='nr-footer__social-item'>
                    <a
                      className='nr-footer__link nr-footer__links'
                      rel='noopener'
                      href='https://www.flickr.com/photos/bp_images'
                      target='_blank'
                    >
                      <img
                        src='https://bp-com-cm.navitas.bpglobal.com/content/dam/bp/master-site/en/global/home/images/social_icons/two-dots.svg'
                        width='20px'
                        height='20px'
                        className='nr-footer__icon'
                        alt='Flickr'
                      />
                    </a>
                  </li>
                </ul>
                <div className='nr-footer__disclaimer'>
                  <a
                    href='/en/global/corporate/disclaimer.html'
                    className='nr-footer__disclaimer-title'
                  >
                    Disclaimer
                  </a>
                  <span className='nr-footer__disclaimer-content'>
                    *Market data delayed by 20 minutes. Delivered by Investis.{' '}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default NavAppWrapper
